<template>
    <div>
        <MeasurementItem
            v-if="battery"
            :title="battery.title"
            :datetime="battery.lastUpdated"
            :link-to="battery.link"
        >
            <template #icon>
                <BatteryIcon
                    width="24"
                    height="24"
                    :battery-level-in-percent="battery.value"
                />
            </template>

            <template #content>
                {{ $t('shared.measurements.battery') }}:

                <h3 class="sensor-data-percentage">
                    {{ battery.value }}
                </h3>
            </template>
        </MeasurementItem>

        <MeasurementItem
            v-if="batteryStatus"
            :title="batteryStatus.title"
            :datetime="batteryStatus.lastUpdated"
            :link-to="batteryVoltage ? batteryVoltage.link : null"
        >
            <template #icon>
                <BatteryIcon
                    width="24"
                    height="24"
                    :battery-status="batteryStatus.value"
                />
            </template>

            <template #content>
                {{ $t('shared.measurements.battery') }}:

                <h3>
                    {{
                        $t(
                            'shared.measurementOptions.battery_status.' +
                                batteryStatus.value
                        )
                    }}

                    <template v-if="batteryVoltage">
                        ({{ batteryVoltage.value }} V)
                    </template>
                </h3>
            </template>
        </MeasurementItem>

        <MeasurementItem
            v-else-if="!battery && batteryVoltage"
            :title="batteryVoltage.title"
            :datetime="batteryVoltage.lastUpdated"
            :link-to="batteryVoltage.link"
        >
            <template #icon>
                <BatteryIcon
                    width="24"
                    height="24"
                    :battery-level-in-percent="100"
                />
            </template>

            <template #content>
                {{ $t('shared.measurements.battery_voltage') }}:

                <h3 class="sensor-data-voltage">
                    {{ batteryVoltage.value }}
                </h3>
            </template>
        </MeasurementItem>
    </div>
</template>

<script>
import BatteryIcon from './icons/BatteryIcon'
import MeasurementItem from './MeasurementItem'
import MeasurementListHelper from '../mixins/MeasurementListHelper'

export default {
    name: 'BatteryMeasurementsFragment',
    components: {
        BatteryIcon,
        MeasurementItem,
    },
    mixins: [MeasurementListHelper],
    computed: {
        battery() {
            return this.getMeasurementItem('battery')
        },
        batteryStatus() {
            return this.getMeasurementItem('battery_status')
        },
        batteryVoltage() {
            return this.getMeasurementItem('battery_voltage')
        },
    },
}
</script>
